export default __webpack_public_path__ + "static/media/BA6.d5d5ec73.jpg";